export default {
  title: 'Autorizații de construcție emise',
  x_axis: 'An',
  y_axis: 'Numărul de autorizații',
  districts: {
    Alanya: 'Alanya',
    Konyaalti: 'Konyaaltı',
    Kemer: 'Kemer',
    Kepez: 'Kepez',
    Dosemealti: 'Döşemealtı',
    Finike: 'Finike'
  }
}
